import { Provider } from '@servicetitan/react-ioc';
import { LoginStore } from '../../stores/login.store';
import { LoginForm } from '../login-form/login-form';
import { LoginLayout } from '../login-layout/login-layout';
import { CaptchaStore, CaptchaApi } from 'components';
import {
    BASE_URL_TOKEN_IdentitySystemApi,
    IdentitySystemApi,
} from '../../../api/identity.system.api';

export const LoginRouter = () => (
    <Provider
        singletons={[
            {
                provide: BASE_URL_TOKEN_IdentitySystemApi,
                useValue: 'https://go.servicetitan.com',
            },
            LoginStore,
            IdentitySystemApi,
            CaptchaApi,
            CaptchaStore,
        ]}
    >
        <LoginLayout children={<LoginForm />} />
    </Provider>
);
